import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "video-container" }
const _hoisted_2 = ["src", "autoplay", "loop", "muted"]

import {
  computed,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from "vue";


const __default__ = {
  name: "VideoWidget",
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
  config: {
    type: Object,
    required: true,
  },
  queueAudioPlaying: {
    type: Boolean,
    required: true,
  },
},
  setup(__props) {

const props = __props;

//mute video when audio starts
const videoRef = ref<HTMLVideoElement | null>(null);
const isActuallyMuted = ref(false);
const isVideoLoaded = ref(false);
let unmuteTimeout: number | null = null;
watch(
  () => props.queueAudioPlaying,
  (newVal) => {
    if (newVal) {
      // mute immediately when audio starts
      isActuallyMuted.value = true;
      if (unmuteTimeout) {
        clearTimeout(unmuteTimeout);
        unmuteTimeout = null;
      }
    } else {
      // unmute after 1 second when audio stops
      unmuteTimeout = window.setTimeout(() => {
        isActuallyMuted.value = false;
        unmuteTimeout = null;
      }, 1000);
    }
  },
  { immediate: true }
);

const muteVideo = computed(() => {
  if (props.config.muted) return true;
  return isActuallyMuted.value;
});

//src video offline
const isOnline = ref(navigator.onLine);
const androidVideoPath = ref("");
const videoSource = computed(() => {
  if (isOnline.value && props.config?.src) {
    return props.config.src;
  }
  return androidVideoPath.value || "";
});

const setAndroidVideoPath = (path: string) => {
  if (path.startsWith("data:video/mp4;base64,")) {
    androidVideoPath.value = path;
    console.log("Received base64 video data");
  } else {
    console.warn("Invalid video path format");
  }
};

const updateOnlineStatus = () => {
  isOnline.value = navigator.onLine;
  console.log(
    `Connection status changed: ${isOnline.value ? "Online" : "Offline"}`
  );
};

function handleVideoError() {
  console.error('Error loading video:', videoSource.value);
  isVideoLoaded.value = false;
}

onMounted(() => {
  (window as any).setAndroidVideoPath = setAndroidVideoPath;
  if ((window as any).AndroidInterface) {
    (window as any).AndroidInterface.getVideoPath();
  } else {
    console.log("Android interface not available");
  }
  updateOnlineStatus();
  window.addEventListener("online", updateOnlineStatus);
  window.addEventListener("offline", updateOnlineStatus);
});

onBeforeUnmount(() => {
  if (unmuteTimeout) clearTimeout(unmuteTimeout);
  window.removeEventListener("online", updateOnlineStatus);
  window.removeEventListener("offline", updateOnlineStatus);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("video", {
      ref_key: "videoRef",
      ref: videoRef,
      src: videoSource.value,
      autoplay: __props.config.autoPlay,
      loop: __props.config.loop,
      muted: muteVideo.value,
      onLoadeddata: _cache[0] || (_cache[0] = ($event: any) => (isVideoLoaded.value = true)),
      onLoadstart: _cache[1] || (_cache[1] = ($event: any) => (isVideoLoaded.value = false)),
      onError: handleVideoError,
      class: _normalizeClass(["video-fill", { 'video-hidden': !isVideoLoaded.value }])
    }, null, 42, _hoisted_2)
  ]))
}
}

})